import { AcademicStaffView } from '@/views/AcademicStaffView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

export const AcademicStaffPage = () => (
  <MainLayout meta={{ title: 'Academic staff' }}>
    <AcademicStaffView />
  </MainLayout>
);
